import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { CategoriesModel } from '@domain/entities/categories.model';
import { CategoriesServerModel } from '@domain/entities/categories.model';

export abstract class CategoriesGateway {
    abstract read(params?: HttpParams): Observable<CategoriesServerModel[]>;
    abstract create(form: CategoriesModel): Observable<CategoriesServerModel>;
    abstract readById(id: number): Observable<CategoriesServerModel>;
    abstract update(
        id: number,
        form: CategoriesModel
    ): Observable<CategoriesServerModel>;
    abstract delete(id: number): Observable<CategoriesServerModel>;
}
